<template>
    <div>
        <Head style="backgroundColor: #fff;"></Head>
        <navigationbar cid="0"></navigationbar>
        <div class='bg-top'></div>
        <div class="wrap flex flex-direction align-center">
            <!-- 顶部背景图 -->
            <!-- <div class='bg-top'></div> -->

            <!-- 中部内容区域 -->
            <div class='content'>
                <!-- <div class='cate width bg-color-ff flex align-center'>
                    <p class="font-size-24 font-color-0cb">活动分类</p>
                    <p class="cate-item font-size-24 font-color-1b" :class="cate_sel_index==index?'sel':'font-color-1b'"  v-for="(item,index) in cate_list" :key="item.Id" @click="catesel(index)">
                        {{ item.CatelogName }}
                    </p>
                </div> -->

                <!-- 活动列表 -->
                <div v-if="list_length>0"  class="list-wrap bg-color-ff width flex flex-direction justify-center">
                    <div class='list bg-color-ff flex flex-wrap'>
                        <div class="item flex align-center cursor-pointer" v-for="(item,index) in data_list" :key="index" @click="pushDetail(index)">
                            <div class="img" :style="{backgroundImage: 'url('+item.ImageUrl+')'}"></div>
                            <div class="info flex flex-direction justify-between">
                                <div class=" flex flex-direction">
                                    <p class="title font-color-33 font-size-24 font-bold">{{item.Title}}</p>
                                    <p class="sub-title font-size-16 font-color-9b">{{item.Intro}}</p>
                                </div>
                                <p class="date font-size-16 font-color-9b">{{item.StartTime}}</p>
                            </div>
                        </div>
                    </div>
                    <!-- 分页器 -->
                    <div style="margin: 0.5rem auto">
                        <paginate v-if="totalpage>1" :pages="totalpage" :groups="totalpage<5?totalpage:5" @jump="jumpIndex"></paginate>
                    </div>
                </div>
                <div v-else class="list-wrap-empty bg-color-ff width flex flex-direction flex-center">
                    <div class="empty-img"></div>
                    <p class="des">敬请期待...</p>
                </div>
            </div>

            <!-- 底部背景图 -->
            <!-- <div class='bg-bottom'></div> -->
        </div>
    </div>
</template>

<script>
    import common from "@/utils/common.js";
    export default {
        data() {
            return {
                cate_list: [
                    {
                        Id: 0,
                        CatelogName:'全部'
                    },
                     {
                        Id: 1,
                        CatelogName:'英语'
                    },
                     {
                        Id: 2,
                        CatelogName:'阅读'
                    },
                     {
                        Id: 3,
                        CatelogName:'活动'
                    }
                ],
                cate_sel_index: 0,
                pageindex:1,
                data_list: [],
                totalpage:1
            }
        },
        computed: {
            list_length() {
                return this.cate_list.length 
            }
        },
        created () {
            this.request();
        },
        methods: {
            catesel(index) {
                this.cate_sel_index = index
            },
            request(){
                var that = this
                let params = {
                    PageIndex: this.pageindex,
                    PageSize: 20
                }
                this.getRequest('api/v1/Article/List',params).then(result=>{
                    if (result.IsSuccess) {
                        that.data_list = result.Data.DataList
                        result.Data.DataList.forEach(item => {
                            item.StartTime = common.formatDateYMD(item.StartTime).allDate
                        });
                        that.totalpage = result.Data.TotalPage
                    }
                })
            },
            pushDetail(index){
                this.$router.push({
                    name:"detail",
                    params:{
                        Id:this.data_list[index].Id
                    }
                })
            },
            jumpIndex(page){
                this.pageindex = page
                this.request()
            }
        },
    }
</script>

<style scoped>

    .bg-top {
  background: url("../../assets/icon-bg.jpg");
  background-size: cover;
  background-position: center bottom;
  background-repeat: no-repeat;
  width: 100%;
  height: 100%;
  /* background-size: 100% auto; */
  position: fixed;
  /* height: 5.05rem; */
  top: 0;
  left: 0;
  z-index: -1;
  background-color: #cbfeee;
}

.wrap {
  padding-bottom: 0.56rem;
  width: 100%;
}

    .content {
        margin-top: 0.4rem;
        z-index: 2;
    }

    .content .cate {
        height: 1.03rem;
        border-radius: 0.16rem;
        margin-bottom: 0.26rem;
        padding: 0 0.4rem;
        box-shadow: 0 0 0.22rem 0.05rem rgba(155, 199, 219, 0.35);
    }

    .content .cate p:first-child {
        margin-right: 0.3rem;
    }

    .cate .cate-item {
        line-height: 0.46rem;
        padding: 0 0.49rem;
        text-align: center;
        height: 0.46rem;
    }

    .cate .sel {
        background-color: #FFCB05;
        border-radius: 0.49rem;
        color: #fff;
    }

    .cate .none {
         color: #1b1b1b;
    }

    .content .list-wrap {
        border-radius: 0.16rem;
        box-shadow: 0 0 0.22rem 0.05rem rgba(142, 175, 190, 0.35);
        padding: 0.2rem 0.4rem;
    }

    .content .list {
        min-height: 7.6rem;
        border-radius: 0.16rem;
        align-content: flex-start;
    }

    .content .list .item {
        border-bottom: 0.01rem #ddd dashed;
        width: calc(100%/2);
        height: 1.93rem;
        padding-right: 0.3rem;
    }

    .content .list .item:nth-child(2n) {
        padding-right: 0;
    }

    .content .list .item .title {
        line-height: 0.32rem;
        max-height: 0.32rem;
        overflow: hidden;
        word-break: break-all;
        text-overflow: ellipsis;
        margin-bottom: 0.1rem;
    }
    .content .list .item .sub-title {
        line-height: 0.26rem;
        text-overflow: ellipsis;
        overflow: hidden;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
    }


    .content .list .item .img {
        width: 1.83rem;
        height: 1.29rem;
        margin-right: 0.27rem;
        background-size: cover;
        background-position: center;
        background-repeat: no-repeat;
        flex-shrink: 0;
    }

    .content .list .info {
        height: 100%;
        padding: 0.3rem 0;
    }

    .list-wrap-empty {
        height: 7.6rem;
    }

    .list-wrap-empty .empty-img {
        width: 2.89rem;
        height: 2.89rem;
        background: url('../../assets/news/icon-news-empty.png') no-repeat center;
        background-size: 100%;
    }

    .list-wrap-empty .des {
        font-size: 0.6rem;
        color: #9b9b9b;
        font-weight: 200;
    }

</style>


// WEBPACK FOOTER //
// src/view/news/news.vue